import { BaseService } from 'components/base/base-service';
import { apiService } from 'libs/axios/services';

export abstract class IExportTaskService extends BaseService<
    TExportTask,
    IRegisterExportRequest,
    IUpdateExportRequest
> {}

export class ExportTaskService extends IExportTaskService {
    path = '/export-task';
    notFoundMessage = 'Export task not found';

    getAll(request: ExportListRequest): Promise<ApiResponse<ResponseBase<TExportTask[]>>> {
        return apiService.get<ExportListRequest, ResponseBase<TExportTask[]>>(
            `${this.path}/list`,
            request,
            undefined,
            true,
        );
    }
    getById(_id: string): Promise<any> {
        return apiService.get<string, any>(`${this.path}/${_id}`);
    }
    create(request: IRegisterExportRequest): Promise<any> {
        return apiService.post<IRegisterExportRequest, any>(`${this.path}/`, request);
    }
    update(_id: string, request: IUpdateExportRequest): Promise<any> {
        return apiService.put<IUpdateExportRequest, any>(
            `${this.path}/${_id}`,
            request,
            undefined,
            true,
        );
    }
    deleteAll(_ids: string[]): Promise<any> {
        return apiService.delete<IExportTaskDeleteRequest, any>(
            `${this.path}/list`,
            undefined,
            undefined,
            {
                headers: { 'Content-Type': 'application/json' },
                data: { task_ids: _ids },
            },
            true,
        );
    }
    deleteById(_id: string): Promise<void> {
        throw new Error('Method not implemented.');
    }
    downloadCSV(_params?: URLSearchParams): Promise<ApiResponse<any>> {
        throw new Error('Method not implemented.');
    }
}
